module.exports = __webpack_public_path__ + "static/img/icon_shuzibiaoxing_pinggu.7f0da04f.png";